import { getMainEmail, getMainPhone } from './contactProfile';

const triggerDownload = (content, filename, mime) => {
  const blob = new Blob([content], { type: mime });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

const csvCell = (v) => {
  const s = v == null ? '' : String(v);
  // Échappe les guillemets et entoure si nécessaire (séparateur ; pour Excel FR)
  if (/[";\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

/** Exporte les contacts en CSV (Excel FR, séparateur point-virgule, BOM UTF-8). */
export const exportContactsCSV = (contacts, filename = 'contacts.csv') => {
  const headers = ['Nom', 'Prénom', 'Société', 'Téléphone', 'Email'];
  const rows = contacts.map((c) => [
    csvCell(c.nom),
    csvCell(c.prenom),
    csvCell(c.societe || c.nom_societe),
    csvCell(getMainPhone(c)),
    csvCell(getMainEmail(c)),
  ].join(';'));
  const content = '\uFEFF' + [headers.join(';'), ...rows].join('\r\n');
  triggerDownload(content, filename, 'text/csv;charset=utf-8');
};

/** Exporte les contacts en vCard 3.0 (.vcf, carnet d'adresses). */
export const exportContactsVCard = (contacts, filename = 'contacts.vcf') => {
  const cards = contacts.map((c) => {
    const nom = c.nom || '';
    const prenom = c.prenom || '';
    const societe = c.societe || c.nom_societe || '';
    const email = getMainEmail(c);
    const phone = getMainPhone(c);
    const lines = [
      'BEGIN:VCARD',
      'VERSION:3.0',
      `N:${nom};${prenom};;;`,
      `FN:${`${prenom} ${nom}`.trim() || 'Contact'}`,
    ];
    if (societe) lines.push(`ORG:${societe}`);
    if (phone) lines.push(`TEL;TYPE=CELL:${phone}`);
    if (email) lines.push(`EMAIL;TYPE=INTERNET:${email}`);
    lines.push('END:VCARD');
    return lines.join('\r\n');
  });
  triggerDownload(cards.join('\r\n'), filename, 'text/vcard;charset=utf-8');
};
